import React from 'react'
import TabView from '../components/TabView'

const PressTab = ({tab, data}) => <TabView tab={tab} data={data}/>

export default PressTab
